'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _intonation = require('./intonation');

var _intonation2 = _interopRequireDefault(_intonation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var meantone = '! meanquar.scl\n!\n1/4-comma meantone scale. Pietro Aaron\'s temperament (1523)\n 12\n!\n 76.04900\n 193.15686\n 310.26471\n 5/4\n 503.42157\n 579.47057\n 696.57843\n 25/16\n 889.73529\n 1006.84314\n 1082.89214\n 2/1\n';

var shares = '! shares.scl\n!\nA scale based on shares of wealth\n!\n1.\n5.\n15.\n32.\n52.\n78.\n116.\n182.\n521.\n1000.\n';

var shares_sum = '! shares_sum.scl\n!\nA scale based on summing shares of wealth\n!\n1\n6.0\n21.0\n53.0\n105.0\n183.0\n299.0\n481.0\n1002.0\n2/1\n';

var mavila = '! mavila12.scl\n!\nA 12-note mavila scale (for warping meantone-based music), 5-limit TOP\n 12\n!\n-30.99719\n 163.50770\n 358.01258\n 327.01540\n 521.52028\n 490.52310\n 685.02798\n 654.03080\n 848.53568\n 1043.04057\n 1012.04338\n 1206.54826\n';

var carlos_alpha = '! carlos_alpha.scl\n!\nWendy Carlos\' Alpha scale with perfect fifth divided in nine\n 18\n!\n 78.00000\n 156.00000\n 234.00000\n 312.00000\n 390.00000\n 468.00000\n 546.00000\n 624.00000\n 702.00000\n 780.00000\n 858.00000\n 936.00000\n 1014.00000\n 1092.00000\n 1170.00000\n 1248.00000\n 1326.00000\n 1404.00000\n';

var lamonte = '! young-lm_piano.scl\n!\nLaMonte Young\'s Well-Tempered Piano\n12\n!\n567/512\n9/8\n147/128\n21/16\n1323/1024\n189/128\n3/2\n49/32\n7/4\n441/256\n63/32\n2/1\n';

var colundi = '! colundi.scl\n!\nColundi scale\n10\n!\n9/8\n171/140\n137/112\n43/35\n3/2\n421/280\n213/140\n263/150\n66/35\n2/1\n';

var liu_major = '! liu_major.scl\n!\nLinus Liu\'s Major Scale, see his 1978 book, "Intonation Theory"                 \n 7\n!\n 10/9\n 100/81\n 4/3\n 3/2\n 5/3\n 50/27\n 2/1\n';
var liu_pentatonic = '! liu_pent.scl\n!\nLinus Liu\'s "pentatonic scale"                                                  \n 7\n!\n 9/8\n 81/64\n 27/20\n 3/2\n 27/16\n 243/128\n 81/40\n';

var liu_minor = '! LIU_MINor.scl\n!\nLinus Liu\'s Harmonic Minor                                                      \n 7\n!\n 10/9\n 6/5\n 4/3\n 40/27\n 8/5\n 50/27\n 2/1\n';

var liu_melodic_minor = '! liu_mel.scl\n!\nLinus Liu\'s Melodic Minor, use 5 and 7 descending and 6 and 8 ascending         \n 9\n!\n 10/9\n 6/5\n 4/3\n 3/2\n 81/50\n 5/3\n 9/5\n 50/27\n 2/1\n';

var scales = [{
  intervals: '1/1 9/8 5/4 4/3 3/2 5/3 15/8 2/1',
  name: "harmonic scale"
}, {
  root: 450,
  intervals: '1/1 9/8 5/4 4/3 3/2 5/3 15/8 2/1',
  name: "harmonic scale @ 450"
}, {
  tet: 5
}, {
  tet: 12
}, {
  tet: 17
}, {
  intervals: '1/1 81/80 33/32 21/20 16/15 12/11 11/10 10/9 9/8 8/7 7/6 32/27 6/5 11/9 5/4 14/11 9/7 21/16 4/3 27/20 11/8 7/5 10/7 16/11 40/27 3/2 32/21 14/9 11/7 8/5 18/11 5/3 27/16 12/7 7/4 16/9 9/5 20/11 11/6 15/8 40/21 64/33 160/81 2/1',
  name: "harry partch scale"
}, {
  scl: lamonte
}, {
  scl: meantone
}, {
  scl: mavila
}, {
  scl: carlos_alpha
}, {
  scl: colundi
}, {
  scl: shares
}, {
  scl: shares_sum
}, {
  scl: liu_major
}, {
  scl: liu_minor
}, {
  scl: liu_melodic_minor
}, {
  scl: liu_pentatonic
}].map(function (opt) {
  return new _intonation2.default(opt);
});

var scale = scales[0];
var handleChange = function handleChange() {};

function build() {
  scales.forEach(function (scale, i) {
    scale.heading = document.createElement('div');
    scale.heading.innerHTML = scale.name;
    scale.heading.classList.add('heading');
    scale.heading.addEventListener('click', function () {
      pick(i);
    });
    scale_list.appendChild(scale.heading);
  });
  pick(0);
}
function build_options(el) {
  scales.forEach(function (scale, i) {
    var option = document.createElement('option');
    option.innerHTML = scale.name;
    option.value = i;
    el.appendChild(option);
  });
  el.addEventListener('input', function (e) {
    pick(e.target.value);
  });
  pick(0);
}

function pick(i) {
  if (scale) {
    scale.heading && scale.heading.classList.remove('selected');
  }
  scale = scales[i];
  scale.heading && scale.heading.classList.add('selected');
  handleChange(scale);
}

function current() {
  return scale;
}

function onChange(fn) {
  handleChange = fn;
}

function names() {
  return scales.map(function (scale) {
    return scale.name;
  });
}

exports.default = { scales: scales, current: current, build: build, build_options: build_options, pick: pick, names: names, onChange: onChange };


//////////////////
// WEBPACK FOOTER
// ./client/lib/scales.js
// module id = 64
// module chunks = 0